export default __webpack_public_path__ + "static/media/AG11.85df4422.mp3";